/* ELA_UNIT_PRICE_DYNAMIC_CARDS_20261025
   * Globo Smart Product Filter rebuilds collection cards from its own API.
   * Keep unit prices visible after every dynamic render.
   */
(function () {
  'use strict';

  var products = [
    { handle: '/products/carte-mifare-blanche-sans-logo', unit: '€3,90', suffix: ' / carte', compare: null },
    { handle: '/products/tag-rfid-mifare-23x56mm-mifare-1k-eurokey-next', unit: '€3,92', suffix: ' / tag', compare: '€4,35' },
    { handle: '/products/cle-pour-systeme-okey-bleue', unit: '€7,00', suffix: ' / clé', compare: null },
    { handle: '/products/carte-mifare-personnalisee-bkf', unit: '€4,41', suffix: ' / carte', compare: '€4,90', title: 'Carte MIFARE personnalisée pour lecteur Eurokey Next – Lot de 100', image: 'https://cdn.shopify.com/s/files/1/0918/5801/0453/files/carte-mifare-personnalisee-votre-logo.png?v=1792956997' }
  ];

  function patchCard(card, config) {
    if (!card) return;
    var marker = 'true:' + config.handle;
    if (card.getAttribute('data-ela-unit-price') === marker) return;
    var priceList = card.querySelector('.product-item__price-list');
    var price = priceList && priceList.querySelector('.price:not(.price--compare)');
    if (!price) return;

    price.textContent = config.unit;
    price.setAttribute('aria-label', config.unit + ' HT' + config.suffix);

    /* ELA_PERSONALIZED_CARD_VISUAL_20261025 */
    if (config.title) {
      var title = card.querySelector('.product-item__title');
      if (title) title.textContent = config.title;
    }
    if (config.image) {
      var cardImage = card.querySelector('.product-item__primary-image, img');
      if (cardImage) {
        var sizedImage = config.image + (config.image.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        cardImage.setAttribute('src', sizedImage);
        cardImage.setAttribute('srcset', sizedImage);
        cardImage.setAttribute('data-src', sizedImage);
        cardImage.setAttribute('data-srcset', sizedImage);
        cardImage.removeAttribute('sizes');
      }
    }

    var suffix = priceList.querySelector('.ela-card-unit-suffix');
    if (!suffix) {
      suffix = document.createElement('span');
      suffix.className = 'ela-card-unit-suffix';
      suffix.style.marginLeft = '4px';
      price.insertAdjacentElement('afterend', suffix);
    }
    suffix.textContent = config.suffix;

    var compare = priceList.querySelector('.price--compare');
    if (config.compare && compare) compare.textContent = config.compare;
    card.setAttribute('data-ela-unit-price', marker);
  }

  function patchAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    for (var p = 0; p < products.length; p += 1) {
      var config = products[p];
      var links = scope.querySelectorAll('a[href*="' + config.handle + '"]');
      for (var i = 0; i < links.length; i += 1) {
        patchCard(links[i].closest('.product-item'), config);
      }
    }
  }

  var queued = false;
  function schedulePatch() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      patchAll(document);
    });
  }

  patchAll(document);
  document.addEventListener('DOMContentLoaded', schedulePatch);
  window.addEventListener('load', schedulePatch);
  window.addEventListener('pageshow', schedulePatch);
  new MutationObserver(schedulePatch).observe(document.documentElement, { childList: true, subtree: true });
}());
